export function BriefcaseEmpty({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="200"
        height="145"
        viewBox="0 0 200 145"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M96.9999 25C94.3333 33 94.6666 41 97.9999 49"
          stroke="var(--clr-title)"
          strokeOpacity="0.2"
          strokeWidth="2.4"
          strokeLinecap="round"
          strokeDasharray="1 7"
        />
        <path
          d="M82 58V69H118V58C118 51.3333 114.667 48 108 48H92C85.3333 48 82 51.3333 82 58Z"
          fill="var(--clr-container-bg)"
          stroke="var(--clr-border-grey-100)"
          strokeLinecap="round"
        />
        <path
          d="M132 69H68C60.268 69 54 75.268 54 83V125C54 132.732 60.268 139 68 139H132C139.732 139 146 132.732 146 125V83C146 75.268 139.732 69 132 69Z"
          fill="var(--clr-container-bg)"
          stroke="var(--clr-border-grey-100)"
        />
        <path d="M54 91H146" stroke="var(--clr-border-grey-100)" />
        <path
          d="M104 84H96C94.3431 84 93 85.3431 93 87V93C93 94.6569 94.3431 96 96 96H104C105.657 96 107 94.6569 107 93V87C107 85.3431 105.657 84 104 84Z"
          fill="var(--clr-general-primary)"
        />
        <path
          d="M84 109C88 113.667 92 113.667 96 109"
          stroke="var(--clr-general-description)"
          strokeLinecap="round"
        />
        <path
          d="M104 109C108 113.667 112 113.667 116 109"
          stroke="var(--clr-general-description)"
          strokeLinecap="round"
        />
        <path
          d="M92 123C97.3333 127 102.667 127 108 123"
          stroke="var(--clr-general-description)"
          strokeLinecap="round"
        />
        <path
          opacity="0.18"
          d="M78.5 121.5C80.1569 121.5 81.5 120.157 81.5 118.5C81.5 116.843 80.1569 115.5 78.5 115.5C76.8431 115.5 75.5 116.843 75.5 118.5C75.5 120.157 76.8431 121.5 78.5 121.5Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.18"
          d="M118.5 121.5C120.157 121.5 121.5 120.157 121.5 118.5C121.5 116.843 120.157 115.5 118.5 115.5C116.843 115.5 115.5 116.843 115.5 118.5C115.5 120.157 116.843 121.5 118.5 121.5Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.9"
          d="M97 19.0003C98.1666 11.8842 103.721 8.86008 108.791 12.2207C106.162 17.9728 101.289 20.2656 97 19.0003Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.65"
          d="M97 19.0004C91.2479 16.3711 90.3192 10.0357 94.4111 5.64758C98.7993 9.73957 99.6787 14.6616 97 19.0004Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.45"
          d="M30 55L32 60L37 62L32 64L30 69L28 64L23 62L28 60L30 55Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.4"
          d="M160.6 109.2C162.036 109.2 163.2 108.036 163.2 106.6C163.2 105.164 162.036 104 160.6 104C159.164 104 158 105.164 158 106.6C158 108.036 159.164 109.2 160.6 109.2Z"
          fill="var(--clr-general-primary)"
        />
      </svg>
    </span>
  );
}
